<template>
  <div>
    <div class="col-md-12">
      <div class="modal-body">
        <label>Start Date</label>
        <input type="date" v-model="params.startDate" class="form-control" />
        <label>End Date</label>
        <input type="date" v-model="params.enddDate" class="form-control" />
      </div>
      <div class="modal-footer">
        <button
          @click="getReportUser()"
          type="button"
          class="btn btn-secondary"
        >
          My Report
        </button>
        <button
          @click="getReportRegion()"
          type="button"
          class="btn btn-primary"
        >
          Regional Report
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { authHeader, responseCheck, StatURL, downloadblob } from "../../helper";
import instance from "../../helper/http";
export default {
  data() {
    return {
      params: {
        startDate: "",
        enddDate: "",
      },
    };
  },
  methods: {
    getReportUser() {
      let loader = this.$loading.show();
      instance
        .get(
          StatURL +
            "userstat?startDate=" +
            this.params.startDate +
            "&endDate=" +
            this.params.enddDate,
          {
            headers: authHeader(),
            responseType: "blob",
          }
        )
        .then((response) => {
          downloadblob("userstat.txt", response.data, "text/plain");
          loader.hide();
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status);
        });
    },
    getReportRegion() {
      let loader = this.$loading.show();
      instance
        .get(
          StatURL +
            "regionstat?startDate=" +
            this.params.startDate +
            "&endDate=" +
            this.params.enddDate,
          {
            headers: authHeader(),
            responseType: "blob",
          }
        )
        .then((response) => {
          downloadblob("regionstat.txt", response.data, "text/plain");
          loader.hide();
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status);
        });
    },
  },
};
</script>